import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

const DashboardHeader = (props) => {
    useEffect(() => {}, []);

    return (
        <Grid container className="page-header">
            <Grid item xs={12}>
                <Grid container direction={"row"}>
                    <Grid item xs={6} textAlign={"start"}>
                        <h3>Ventas por ejecutivo</h3>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

// export default Modal;
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardHeader);
